import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, NgForm, Validators} from '@angular/forms';
import {ProductService} from '../../../../Services/product.service';

export interface ProductCollies {
  id: number;
  name: string;
}

@Component({
  selector: 'app-collies-form',
  templateUrl: './collies-form.component.html',
})
export class ColliesFormComponent implements OnInit {
  @Input() colliesForm: UntypedFormGroup;
  @Input() productId: number;
  @Input() productCollies: ProductCollies[];
  @ViewChild('productColliesForm', {static: false}) productColliesForm!: NgForm;
  public hasCollies = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private productService: ProductService
  ) {
  }

  ngOnInit(): void {
    this.initProductColliesForm();
  }

  public initProductColliesForm() {
    this.hasCollies = this.hasColliesItems();

    this.colliesForm = this.formBuilder.group({
      collies: this.formBuilder.array(
        this.generateColliesFormArrayItem()
      )
    });
  }

  private hasColliesItems() {
    return this.productCollies.length > 0;
  }

  private generateColliesFormArrayItem() {
    if (this.hasColliesItems()) {
      return this.productCollies.map(collies => this.createColliesFormGroup(collies));
    } else {
      return [
        this.createColliesFormGroup(null),
        this.createColliesFormGroup(null)
      ];
    }
  }

  public createColliesFormGroup(collies = null): UntypedFormGroup {
    const value = collies && collies.name ? collies.name : '';
    return this.formBuilder.group({
      name: [value, Validators.required]
    });
  }

  public addCollies() {
    this.colliesFormArray.push(this.createColliesFormGroup({}));
  }

  public markAllAsTouched() {
    const colliesArray = this.colliesForm.get('collies') as UntypedFormArray;
    colliesArray.controls.forEach(collieGroup => {
      this.markFormGroupTouched(collieGroup as UntypedFormGroup);
    });
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof UntypedFormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  get colliesFormArray(): UntypedFormArray {
    return this.colliesForm.get('collies') as UntypedFormArray;
  }

  public deleteCollie(index: number): void {
    if (index > 1) {
      this.colliesFormArray.removeAt(index);
    }
  }

  public showProductColliesForm($event): void {
    if (!$event) {
      this.hasCollies = $event;
    }
  }

  public onColliesFormSubmit(): void {
    this.markAllAsTouched();

    if (this.colliesForm.invalid) {
      return;
    }

    const productCollies = this.colliesForm.value.collies as ProductCollies;

    this.productService.manageCollies(this.productId, {productCollies: productCollies}).subscribe((res) => {
    });
  }

}
